import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, ButtonVariant } from '@brasshq/ui-kit';
import { CommonContext } from 'src/modules/common/context';

import { MIGRATION_PAGE_ROUTES } from '../../../data/constants';
import { useMigrationPreview } from '../../../hooks/useMigrationPreview';
import { isMigrationProvisionResolved } from '../../../migrationGate';
import { getMigrationProvision } from '../../../storage';
import { getMigrationPreviewProvision } from '../../../utils';

import styles from './AccountDetails.module.scss';

const AccountDetails: React.FC = () => {
  const navigate = useNavigate();
  const { profile } = React.useContext(CommonContext);
  const { isPreview, search } = useMigrationPreview();

  const customerId = profile?.customer?.data?.id || '';
  const provisionedMigration = React.useMemo(() => {
    if (isPreview) return getMigrationPreviewProvision();
    return getMigrationProvision(customerId);
  }, [customerId, isPreview]);

  const isResolved = isMigrationProvisionResolved(provisionedMigration);
  const accountName =
    provisionedMigration?.sweep_funds_to?.name || 'Name could not be resolved yet';
  const accountNumber = provisionedMigration?.account_number || 'Not available';
  const bankName = provisionedMigration?.sweep_funds_to?.bank_name || 'Paystack MFB';

  return (
    <section className={styles.AccountDetails}>
      <div className={styles.AccountDetails_content}>
        <p className={styles.AccountDetails_label}>Step 1</p>
        <h1>Confirm your migration account details</h1>
        <p className={styles.AccountDetails_description}>
          These details come from migration provisioning. We resolve the account name before you
          continue.
        </p>

        <div className={styles.AccountDetails_card}>
          <div className={styles.AccountDetails_row}>
            <span className={styles.AccountDetails_row_label}>Account name</span>
            <span className={styles.AccountDetails_row_value}>{accountName}</span>
          </div>
          <div className={styles.AccountDetails_row}>
            <span className={styles.AccountDetails_row_label}>Account number</span>
            <span className={styles.AccountDetails_row_value}>{accountNumber}</span>
          </div>
          <div className={styles.AccountDetails_row}>
            <span className={styles.AccountDetails_row_label}>Bank</span>
            <span className={styles.AccountDetails_row_value}>{bankName}</span>
          </div>
        </div>

        {!isResolved && !isPreview && (
          <p className={styles.AccountDetails_note}>
            You can continue only after account details are resolved successfully.
          </p>
        )}

        <Button
          type='button'
          variant={ButtonVariant.Primary}
          className={styles.AccountDetails_cta}
          disabled={!isPreview && (!provisionedMigration || !isResolved)}
          onClick={() => navigate(`${MIGRATION_PAGE_ROUTES.exportYourData}${search}`)}
        >
          Continue
        </Button>
      </div>
    </section>
  );
};

export default AccountDetails;
